export default class LoadingManager {
  toLoad = 0;

  loaded = 0;

  isLoaded = true;

  constructor(store = null) {
    this.store = store;
  }

  get isLoaded() {
    return this.isLoaded;
  }

  get percentage() {
    if (this.toLoad === 0) {
      return 100;
    }
    const onePercent = 100 / this.toLoad;
    const rounded = Math.round(this.loaded * onePercent);
    return rounded;
  }

  addLoadingStep(numberOfSteps) {
    if (numberOfSteps == null) {
      this.toLoad += 1;
    } else {
      this.toLoad += numberOfSteps;
    }
    this.update();
  }

  loadingStepLoaded(numberOfSteps) {
    if (numberOfSteps == null) {
      this.loaded += 1;
    } else {
      this.loaded += numberOfSteps;
    }
    this.update();
  }

  hideLoadScreen() {
    this.toLoad = 0;
    this.loaded = 0;
    this.update();
  }

  // Will update store and isLoaded status.
  // Call it to update loading loading status.
  update() {
    // Part 1. Update is loaded status.
    const isLoaded = this.loaded >= this.toLoad;
    if (isLoaded) {
      this.loaded = 0;
      this.toLoad = 0;
    }
    this.isLoaded = isLoaded;

    // Part 2. Update store.
    if (this.store == null) return;
    this.store.commit('loading/updateIsLoaded', this.isLoaded);
    this.store.commit('loading/updatePercentage', this.percentage);
    this.store.commit('loading/updateStepsToLoad', this.toLoad);
    this.store.commit('loading/updateStepsLoaded', this.loaded);
  }
}
